import React, { ReactNode } from 'react'

export type IEcpCard = { children: ReactNode, className?: string } & React.HTMLAttributes<HTMLDivElement>
export const EcpCard = ({ children, className, ...rest }: IEcpCard) =>
  <div className={`ecp-card ${className || ''}`} {...rest}>{children}</div>
